import React from 'react';
import { PCCase } from '../../types';
import { CaseCard } from './CaseCard';
import { Button } from '../ui';
import { useAppStore } from '../../context/store';

interface CaseGridProps {
  cases: PCCase[];
}

export const CaseGrid: React.FC<CaseGridProps> = ({ cases }) => {
  const { resetFilters } = useAppStore();

  if (cases.length === 0) {
    return (
      <div className="flex flex-col items-center gap-3 rounded-xl border border-dashed border-line-strong px-6 py-14 text-center">
        <h3 className="text-base font-medium">No cases match these filters.</h3>
        <p className="text-sm text-muted max-w-md">
          Try removing a filter or lowering the minimum clearances.
        </p>
        <Button variant="outline" onClick={resetFilters} className="mt-2">
          Clear filters
        </Button>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-[repeat(auto-fill,minmax(280px,1fr))] gap-5">
      {cases.map((pcCase) => (
        <CaseCard
          key={pcCase.id}
          pcCase={pcCase}
        />
      ))}
    </div>
  );
};
